import { FC } from "react";

import { CrudEditContextWrapper } from "@ryde/controls";
import {
  DrawerType,
  IInjectedDrawerProps,
  IJourneyEditDrawerProps,
} from "@ryde/shared";

import { DrawerFormProviderWrapper } from "../edit-form";
import { JourneyDrawerEditFormInner } from "./journey-drawer-edit-form-inner";

export const JourneyEditFormDrawer: FC<
  IJourneyEditDrawerProps & IInjectedDrawerProps
> = ({
  onCloseDrawer,
  id,
  idCopyFrom,
  mode,
  resolveFn,
  drawerNumber,
  canResolve,
}) => {
  return (
    <CrudEditContextWrapper
      entity={"journey"}
      id={id}
      idCopyFrom={idCopyFrom}
      mode={mode}
    >
      <DrawerFormProviderWrapper>
        <JourneyDrawerEditFormInner
          type={DrawerType.JourneyEditForm}
          onCloseDrawer={onCloseDrawer}
          mode={mode}
          resolveFn={resolveFn}
          drawerNumber={drawerNumber}
          canResolve={canResolve}
        />
      </DrawerFormProviderWrapper>
    </CrudEditContextWrapper>
  );
};
